import { Component, ViewChild } from '@angular/core';
import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ConstantsService } from '@app/common/constants.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserAuthService } from '@app/shared/services/user-auth.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { BreadcrumbModule } from 'primeng/breadcrumb';

@Component({
    standalone: true,
    selector: 'app-release-progress',
    templateUrl: './release-progress.component.html',
    styleUrls: ['./release-progress.component.scss'],
    providers: [{
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { displayDefaultIndicatorType: false }
        }],
    imports: [CommonModule, MatTooltipModule, MatStepperModule, MatIconModule, BreadcrumbModule]
})
//Shared comoponant to display progress status
export class ReleaseProgressComponent implements ICellRendererAngularComp {
      @ViewChild('stepper', { static: true }) stepper!: MatStepper;
      params: any;
      branchCreationStatus: string; //Variable
      releasePipelineStatus: string; //Variable
      releaseStatus: string; //Variable
      toolTipBranchCreationStatus: string; //Variable
      toolTipReleasePipelineStatus: string; //Variable
      toolTipReleaseStatus: string; //Variable
      readOnlyManifest = false; // Variable to control read-only mode
      readOnlyBranch = false; // Variable to control read-only mode
      editableManifest = false; // Variable to control edit mode
      editableBranch = false; // Variable to control edit mode
      constructor(private readonly serviceConstant: ConstantsService, private readonly router: Router,
            public toastr: ToastrService, public userAuthService: UserAuthService) { }
      //  ag-grid function
      agInit(params): void {
            this.stepper.selectedIndex = null as any;
            this.params = params;
            // set branch creation status
            this.branchCreationStatus = this.params.data.RepoCreationStatus;
            // set release pipeline status
            this.releasePipelineStatus = this.params.data.PipelineCreationStatus;
            // set release status based on branch creation status and release pipeline status     
            if ((this.branchCreationStatus == this.serviceConstant.ReleaseStatusSuccess) && (this.releasePipelineStatus == this.serviceConstant.ReleaseStatusSuccess)) {
                  this.releaseStatus = this.serviceConstant.ReleaseStatusSuccess;
            }
            else {
                  if (this.branchCreationStatus == this.serviceConstant.ReleaseStatusFailed || this.releasePipelineStatus == this.serviceConstant.ReleaseStatusFailed) {
                        this.releaseStatus = this.serviceConstant.ReleaseStatusFailed;
                  }
                  else {
                        this.releaseStatus = this.serviceConstant.ReleaseStatusNew;
                  }
            }

            // set tooltip for branch creation status, release pipeline status and release status
            this.toolTipBranchCreationStatus = this.branchCreationStatus == undefined || this.branchCreationStatus === this.serviceConstant.ReleaseStatusNew ? this.serviceConstant.ReleaseStatusNew : this.branchCreationStatus;
            // set tooltip for release pipeline status
            this.toolTipReleasePipelineStatus = this.releasePipelineStatus == undefined || this.releasePipelineStatus === this.serviceConstant.ReleaseStatusNew ? 'Pending Manifest Creation' : this.releasePipelineStatus;
            // set tooltip for release status
            this.toolTipReleaseStatus = this.releaseStatus == undefined || this.releaseStatus === this.serviceConstant.ReleaseStatusNew ? this.serviceConstant.ReleaseStatusNew : this.releaseStatus;
            // set read-only mode based on user permissions
            this.readOnlyManifest = this.userAuthService.checkPermission('MANAGE.MANIFEST.STATUS.VIEW');
            this.readOnlyBranch = this.userAuthService.checkPermission('MANAGE.BRANCH.STATUS.VIEW');
            // set editableManifest to true if manifest is success
            this.editableManifest = this.releasePipelineStatus === this.serviceConstant.ReleaseStatusSuccess;

            // set editableBranch to true if branch creation is success
            this.editableBranch = this.branchCreationStatus === this.serviceConstant.ReleaseStatusSuccess;
      }

      // ag-grid function
      refresh(params?: any): boolean {
            return true;
      }

      // function to get color code based on status
      getColour(status) {
            switch (status) {
                  case this.serviceConstant.ReleaseStatusNew:
                        return 'grey';
                  case this.serviceConstant.ReleaseStatusSuccess:
                        return 'green';
                  case this.serviceConstant.ReleaseStatusFailed:
                        return 'red'
                  case this.serviceConstant.ReleaseStatusInProgress:
                        return 'orange';
                  default:
                        return 'grey'
            }
      }

      //  get mat-step state based on status
      getState(status) {
            switch (status) {
                  case this.serviceConstant.ReleaseStatusSuccess:
                        return 'done';
                  case this.serviceConstant.ReleaseStatusFailed:
                        return 'error'
                  case this.serviceConstant.ReleaseStatusInProgress:
                        return 'edit';
                  default:
                        return 'new';
            }
      }

      onManifestClick(event) {
            if (this.params?.data?.Id) {
                  event.stopPropagation();
                  this.router.navigate([`/release/manifest-status/${this.params?.data?.Id}`]);
            }
      }
      selectedReleaseStatus: string | null = null;

      onReleaseStatusClick(event: MouseEvent): void {
            if (event) {
                  event.stopPropagation();
            }
            this.router.navigate(['/view-branch-creation-status'], {
                  queryParams: { releaseId: this.params.data?.Id },
            });
      }

      noop() { } // no-operation empty event
selectionChange(event: StepperSelectionEvent) {
  switch (event.selectedIndex) {
    case 0:
      if (this.readOnlyBranch) {
        this.onReleaseStatusClick({ stopPropagation: () => { } } as MouseEvent);
      }
      break;
    case 1:
      if (this.readOnlyManifest) {
        this.onManifestClick({ stopPropagation: () => { } } as MouseEvent);
      }
      break;
    case 2:
      // Handle release status step if needed
      break;
  }
}
}
